<template>
  <div
    class="w-full flex flex-col items-center gap-2 alpha-top p-4 border-4 border-red-800 rounded-lg font-inter"
  >
    <div class="flex flex-row items-center gap-1">
      <font-awesome-icon
        class="text-2xl text-red-600"
        icon="fa-solid fa-exclamation-triangle"
      />
      <span class="text-2xl font-bold text-red-600">Upgrade failed</span>
    </div>
    <p class="text-center">An error occurred while upgrading your account.</p>
    <pre
      v-if="error"
      class="w-full my-2 px-3 py-2 bg-red-600/25 border border-white/10 rounded-md whitespace-pre-wrap"
    >
      {{ error }}
    </pre>
    <p class="text-sm text-center">
      Please try again later or contact support.
    </p>

    <UButton
      color="red"
      variant="outline"
      class="text-lg mt-4"
      @click="$emit('close')"
    >
      Continue
    </UButton>
  </div>
</template>

<script setup>
  defineProps({
    error: {
      type: String,
      required: false,
      default: "",
    },
  })

  defineEmits(["close"])
</script>
